import {
  Component,
  Input,
  OnChanges,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import { TextModes } from '../../../components/ui/controls/text-input/text-input.component';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { UIHelpers } from '../../../core/ui-helpers';
import { Customer } from '../../../models/customer/customer';
import { OrderDetails } from '../../../models/orders/orderDetails';
import { OrderService } from '../../../models/orders/orderService';
import { PaymentMethod } from '../../../models/paymentMethod/paymentMethod';
import { PaymentMethodService } from '../../../models/paymentMethod/paymentMethodService';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { TransactionResponse } from '../../../models/transactions/transactionResponse';
import { TransactionService } from '../../../models/transactions/transactionService';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../../../components/ui/snackbar/custom-snackbar.component';

@Component({
  selector: 'app-terminal-receipt',
  templateUrl: './terminal-receipt.component.html',
  standalone: false,
})
export class TerminalReceiptComponent implements OnChanges {
  @Input() customer: Partial<Customer> | undefined;
  @Input() transactionResponse: TransactionResponse | undefined;
  @Input() transactionType: string | undefined;

  order: OrderDetails | undefined;
  transaction: TransactionFacade | undefined;
  paymentMethod: PaymentMethod | undefined;
  transactionTotal: string | undefined;
  transactionDate: string | undefined;
  orderDate: string | undefined;

  inputTextModes = TextModes;

  customerEmail: string | undefined;

  constructor(
    private orderService: OrderService,
    private transactionService: TransactionService,
    private paymentMethodService: PaymentMethodService,
    private uiHelpers: UIHelpers,
    private uiErrorHandler: UIErrorHandler,
    public snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    if (this.transactionType && this.transactionType == 'AUTHCAPTURE') {
      this.transactionType = 'Sale';
    }
    if (
      this.transactionResponse?.orderId ||
      this.transactionResponse?.transactionId
    ) {
      this.loadReceipt();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['transactionResponse'];

    if (change && change.currentValue && change.currentValue != '') {
      this.loadReceipt();
    }
  }

  handleCustomerSaved(customer: Partial<Customer>) {
    /*
    console.log(this.transaction, customer.id);

    if (this.transaction && customer.id) {

      // update transaction data
      // [service call]
      // ...

      this.transaction.customerId = customer.id;
    }
*/
  }

  handleSendToCustomer() {
    this.transactionService
      .sendTransactionToCustomer(
        this.customerEmail!,
        this.order!,
        this.transaction?.type!,
      )
      .then((response) => {
        this.snackBar?.openFromComponent(CustomSnackbarComponent, {
          duration: 5000,
          panelClass: 'snackbar-success',
          data: {
            message: 'A transaction email has been sent to the customer.',
            fontSize: '1.5em',
            iconSize: '50px',
          },
        });
      })
      .catch((error) => {
        this.snackBar?.openFromComponent(CustomSnackbarComponent, {
          duration: 5000,
          panelClass: 'snackbar-error',
          data: {
            message:
              'There was a problem sending the transaction to the customer: ' +
              error,
            fontSize: '1.5em',
            iconSize: '50px',
          },
        });
      });
  }

  async loadReceipt() {
    if (this.transactionResponse && this.transactionResponse.orderId) {
      //Get the order we just created.
      this.orderService
        .getOrder(this.transactionResponse.orderId)
        .then((order) => {
          if (!order) {
            throw 'order not found';
          }
          this.order = order;
          this.customerEmail = order.recipientEmail;
          this.orderDate = this.uiHelpers.formatDateTime(
            order.createDate.toString(),
            false,
          );

          const currentDate = new Date().toISOString();

          //If the order is recurring and the first charge date it not today, we don't need to fetch the transaction.
          if (
            !(
              this.order.recurringSchedule && Object.keys(this.order.recurringSchedule).length != 0 &&
              this.order.recurringSchedule?.firstChargeDate?.split('T')[0] !==
                currentDate.split('T')[0]
            )
          ) {
            this.transactionService
              .getTransaction(this.transactionResponse!.transactionId)
              .then((t) => {
                this.transaction = t;
                //Get the payment method for the transaction.
                this.paymentMethodService
                  .getPaymentMethod(t.paymentMethodId, t.customerId)
                  .then((pm) => {
                    this.paymentMethod = pm;
                  })
                  .catch((message) => {
                    this.uiErrorHandler.handleError(
                      'unable to load payment method',
                    );
                  });
                this.transactionTotal = t.totalAmount;

                if (t.date) {
                  this.transactionDate = this.uiHelpers.formatDateTime(
                    t.date,
                    false,
                  );
                }
              })
              .catch((message) => {
                this.uiErrorHandler.handleError('transaction not found');
              });
          }
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }
}
